import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from '../translations/en.json';
import deTranslations from '../translations/de.json';


const langs = navigator.language;
const savedLanguage = localStorage.getItem('language') || langs.slice(0, 2) || 'en';
console.log('savedLanguage', savedLanguage);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      de: {
        translation: deTranslations
      }
    },
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 